<template>
  <!-- { 'is-scroll': !sidebar.collapse } -->
	<!-- <div :class="['sidebar','sidebar-float']">
		<p>侧边栏{{ sidebar.collapseMobile }}</p>
     --- {{ sidebar.collapse }}---
	</div> -->
  <!-- {{ sidebar.collapseMobile }} -->
  <div :class="['sidebar-float', 
  {'is-hide': sidebar.collapseMobile}]">
    <!-- {{ sidebar.collapseMobile }}---{{ sidebar.showMobileSideBar }}000{{ drawerBtn }} -->
    <template v-if="drawerBtn">
      <el-drawer
      v-model="drawerBtn"
      title=""
      :direction="direction"
      :with-header="false"
      :open-delay="90000"
      @close="closeDrawer"
    >
      <SideMenuList :menuType="2" />
    </el-drawer>
  </template>
    <!-- {{ sidebar.collapseMobile }}=--- {{ sidebar.collapse }}--- -->
  <!-- <div class="sidebar-float menu-container"> -->
  
	<!-- </div> -->
  </div>
</template>

<script setup>
	import PubSub from "pubsub-js";
  import SideMenuList from "./sideMenuList.vue";
	import { computed,ref,watch,watchEffect } from "vue";
	import { useSidebarStore } from "../stores/sidebar";
	import { useRoute } from "vue-router";
	import menus from "../assets/js/menu";
	const route = useRoute();
	const onRoutes = computed(() => {
		return route.path;
	});

	const sidebar = useSidebarStore();
  var drawerBtn = ref(true)
  // var drawerBtn = ref(true || !sidebar.collapseMobile)

  const direction = ref('ltr');
  // var drawerBtn = ref(true);

//   watchEffect(() => {
//   console.log('当前值为', drawerBtn.value);
// });
// const props = defineProps({
//   open: {
//     type: Boolean,
//     required: true
//   }
// });
// const open = ref(!props.open);
// console.log("open",open.value)
const closeDrawer = () => {
  // drawerBtn.value = false;
  //console.log(sidebar.collapseMobile,'drawerBtn',sidebar)
  // sidebar.collapseMobile = false;
  drawerBtn.value = false
  // sidebar.collapseMobile = true;

  sidebar.handleCollapse();
}
PubSub.subscribe("drawerStatus", (msgName, msgContent) => {
  //console.log(msgName, msgContent)
  drawerBtn.value = true

	});
</script>

<style lang="scss" scoped>
.sidebar-float{
  position: fixed;
  top: 70px;
  left: 0;
  bottom: 0;
  // background: #5E9BE8;
  // width: 280px;
  z-index: 9999;
  border-radius: 0 0 50px 0; 
  ::v-deep(.el-drawer){
    width: 225px!important;
    transition: all 0.4s;//打开滑动时效
  }
  
  &.is-scroll{
	    overflow-y: scroll;
      scrollbar-width: none; /* Firefox 支持 */
      -ms-overflow-style: none;  /* IE/Edge 支持 */
    }
    /* 隐藏滚动条轨道 (Chrome, Safari, Opera) */
    &.is-scroll::-webkit-scrollbar {
      display: none;
    }
		> p {
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			color: #bfcbd9;
		}
    ::v-deep(.el-overlay){
      display: block !important;
    }
    &.is-hide{
      width: 0px;
      // color: red;
      ::v-deep(.el-overlay){
        background-color: transparent;
        display: block !important;
        
      }
      ::v-deep(.el-drawer){
        width: 0px!important;
        transition: all 0.4s;
      }
    }
  }

  .el-menu{
    border-right: none;
  }
</style>
